export enum IconCode {
    MANAGEMENT = 'icon-settings',
    HOME = 'icon-home',
    START = 'icon-start',

    TOOLTIP = 'icon-tooltip',

    // Actions
    EDIT = 'icon-edit',
    DELETE = 'icon-delete',
    ADD = 'icon-add',
    ACTIVATE = 'icon-active',
    REFRESH = 'icon-refresh',
    COPY = 'icon-copy',
    LOCALIZATION = 'icon-location',
    DOWNLOAD = 'icon-download',
    PREVIEW = 'icon-preview',
    DEACTIVATE = 'icon-partner-deactivation',
    DEACTIVATE_SALES = 'icon-sales-deactivation',

    // Localization
    LOCALIZATION_ACTIVATE = ACTIVATE,
    LOCALIZATION_ADD = ADD,
    LOCALIZATION_DEACTIVATE = DELETE,
    LOCALIZATION_EDIT = EDIT,
    LOCALIZATION_MANAGEMENT = LOCALIZATION,
    LOCALIZATION_LIMITED_MANAGEMENT = LOCALIZATION,

    // Partner
    PARTNER_MANAGEMENT = 'icon-mgt-partner',
    PARTNER_ACTIVATE = ACTIVATE,
    PARTNER_ADD = ADD,
    PARTNER_DEACTIVATE = DEACTIVATE,
    PARTNER_DEACTIVATE_SALES = DEACTIVATE_SALES,
    PARTNER_EDIT = EDIT,

    // User
    USER_MANAGEMENT = 'icon-user-bar',
    USER_ACTIVATE = ACTIVATE,
    USER_ADD = ADD,
    USER_DEACTIVATE = DELETE,
    USER_EDIT = EDIT,
    USER_PASS_RESET = REFRESH,

    // Password Policy
    PASSWORD_POLICY_MANAGEMENT = 'icon-password',
    PASSWORD_POLICY_ADD = ADD,
    PASSWORD_POLICY_EDIT = EDIT,
    PASSWORD_POLICY_DELETE = DELETE,

    // Product
    PRODUCT_MANAGEMENT = 'icon-mgt-product',
    PRODUCT_ADD = ADD,
    PRODUCT_PG_DUPLICATE = COPY,
    PRODUCT_PG_EDIT = 'icon-edit',
    PRODUCT_CPI_EDIT = 'icon-edit',
    PRODUCT_CPI_DUPLICATE = COPY,

    // Config
    CONFIG = 'icon-settings',

    TRANSCODER_CONFIGURATION = 'icon-transcoder',
    TRANSCODER_ADD = ADD,
    TRANSCODER_EDIT = EDIT,
    TRANSCODER_DELETE = DELETE,
    TRANSCODER_FORM_ADD = ADD,
    TRANSCODER_FORM_EDIT = EDIT,

    TARIFF_ELEMENTS = 'icon-tariff',

    BRANDS = 'icon-brands',
    BRANDS_ADD = ADD,
    BRANDS_DELETE = DELETE,

    CO_ACQUISITION_CONFIGURATION = 'icon-coacquisition',
    CO_ACQUISITION_ADD = ADD,
    CO_ACQUISITION_EDIT = EDIT,
    CO_ACQUISITION_DELETE = DELETE,

    // Reports
    REPORTS_LIST = 'icon-reports2',

    // Policy
    POLICY_ADD = 'icon-add', // not action icon
    POLICY_REGISTRY = 'icon-registry',
    POLICY_PREVIEW = PREVIEW,
    POLICY_PG = PREVIEW,

    // CPI
    SALES_CPI_PRODUCT_PICK = 'icon-sales-cpi-product-pick',
    SALES_CPI_OFFER_SIMULATE = 'icon-sales-cpi-offer-simulate',
    SALES_CPI_OFFER_DATA = 'icon-sales-cpi-offer-data',
    POLICY_CPI = PREVIEW,

    TARIFF = 'icon-tariff',

    // Documents
    DOCUMENT_MANAGEMENT = 'icon-document-management',
    DOCUMENT_ADD = ADD,
    DOCUMENT_DELETE = DELETE,
    DOCUMENT_EDIT = EDIT,
    DOCUMENT_DOWNLOAD = DOWNLOAD,
    DOCUMENT_VIEW = PREVIEW,

    AMENDMENT = 'icon-amendment', // aside header

    MIGRATED_POLICIES = 'icon-registry',
    MIGRATED_DELETE = DELETE,

    REPOSITORY_POLICIES = 'icon-registry',


}
